module.exports = __webpack_public_path__ + "static/media/fourInnerImg2.3d900ed6.png";